/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  // {
  //   url: "/",
  //   name: "Dashboard",
  //   slug: "dashboard",
  //   icon: "HomeIcon",
  //   i18n: "Dashboard",

  // },
  {
    url: "/dashboard/analytics",
    name: "Dashboard",
    slug: "dashboard",
    icon: "HomeIcon",
    i18n: "Dashboard",
  },
  {
    header: "Timekeeping",
    i18n: "Timekeeping",
    items: [
      {
        url: "/timekeeping/attendancelog",
        name: "Attendance Log",
        slug: "attendancelog",
        icon: "UserIcon",
        i18n: "Attendance Log",
      },
      {
        url: "/timekeeping/timerequest",
        name: "Time Request",
        slug: "timerequest",
        icon: "ClockIcon",
        i18n: "Time Request",
      },
    ],
  },
  // {
  //   url: null,
  //   name: 'Dashboard',
  //   tag: '',
  //   tagColor: 'warning',
  //   icon: 'HomeIcon',
  //   i18n: 'Dashboard',
  //   submenu: [
  //     {
  //       url: '/dashboard/analytics',
  //       name: 'Analytics',
  //       slug: 'dashboard-analytics',
  //       i18n: 'Analytics'
  //     },

  //   ]
  // },
  {
    header: "Self-Service",
    i18n: "SelfService",
    items: [
      {
        url: "/selfservice/leaverequest",
        name: "Leave Request",
        slug: "leaverequest",
        icon: "CalendarIcon",
        i18n: "Leave Request",
      },
      {
        url: "/selfservice/overtimerequest",
        name: "Overtime Request",
        slug: "overtimerequest",
        icon: "SpeakerIcon",
        i18n: "Overtime Request",
      },
      {
        url: "/selfservice/loanrequest",
        name: "Loan Request",
        slug: "loanrequest",
        icon: "CreditCardIcon",
        i18n: "Loan Request",
      },
      {
        url: "/selfservice/claimsrequest",
        name: "Claims Request",
        slug: "claimsrequest",
        icon: "PackageIcon",
        i18n: "Claims Request",
      },
      {
        url: "/selfservice/itrrequest",
        name: "ITR Request",
        slug: "itrrequest",
        icon: "DownloadCloudIcon",
        i18n: "ITR Request",
      },
      {
        url: "/selfservice/coerequest",
        name: "COE Request",
        slug: "coerequest",
        icon: "DownloadCloudIcon",
        i18n: "COE Request",
      },
      {
        url: "/selfservice/schedulerequest",
        name: "Schedule Request",
        slug: "schedulerequest",
        icon: "DownloadCloudIcon",
        i18n: "Schedule Request",
      },
    ],
  },

  {
    header: "Reports",
    i18n: "Reports",
    rule: "user",
    items: [
      {
        url: "/reports/financereports",
        name: "Final Pay Reports",
        slug: "finalpayreports",
        icon: "DollarSignIcon",
        i18n: "Final Pay Reports",
      },

      {
        url: "/reports/generatedpayslips",
        name: "Generated Payslips",
        slug: "generatedpayslips",
        icon: "FileTextIcon",
        i18n: "Generated Payslips",
      },

      {
        url: "/reports/coe",
        name: "COE Request",
        slug: "certificateofemployement",
        icon: "AwardIcon",
        i18n: "COE Request",
      },
    ],
  },

  {
    header: "Managers Launch",
    i18n: "Approval",
    rule: "manager",
    items: [
      {
        url: "/approvals/schedule",
        name: "Schedule",
        slug: "schedule",
        icon: "BookOpenIcon",
        i18n: "Schedule",
        // submenu: [
        //   {
        //     url: '/approvals/create',
        //     name: 'Create Schedule',
        //     slug: 'create-schedule',
        //     i18n: 'Create Schedule'
        //   },
        //   {
        //     url: '/approvals/schedule/view',
        //     name: 'View Schedule',
        //     slug: 'view-schedule',
        //     i18n: 'View Schedule'
        //   }

        // ]
      },
      {
        url: "/approvals/pendingapprovals",
        name: "Pending Approvals",
        slug: "pendingapprovals",
        icon: "CheckSquareIcon",
        i18n: "Pending Approvals",
      },
      {
        url: "/approvals/hrapproval",
        name: "HR Approval",
        slug: "hrapproval",
        icon: "CheckSquareIcon",
        i18n: "HR Approval",
      },
      {
        url: "/approvals/mypeople",
        name: "My People",
        slug: "mypeople",
        icon: "UsersIcon",
        i18n: "My People",
      },
    ],
  },

  {
    header: "HRIS",
    i18n: "HRIS",
    rule: "hr",
    items: [
      {
        url: "/hris/recruitment",
        name: "Recruitment",
        slug: "recruitment",
        icon: "GlobeIcon",
        i18n: "Recruitment",
      },
      {
        url: "/hris/employeelist",
        name: "Employee List",
        slug: "employeelist",
        icon: "UsersIcon",
        i18n: "EmployeeList",
      },
      {
        url: "/hris/bulksalaryupload",
        name: "Bulk Salary Upload",
        slug: "bulksalaryupload",
        icon: "UsersIcon",
        i18n: "Bulk Salary Upload",
      },
      // {
      //   url: "/hris/registeremployee",
      //   name: "Register Employee",
      //   slug: "registeremployee",
      //   icon: "UserPlusIcon",
      //   i18n: "Register Employee",
      // },
      // {
      //   url: "/hris/employeeinformation/:id",
      //   name: "Employee Information",
      //   slug: "employeeinformation",
      //   icon: "InfoIcon",
      //   i18n: "EmployeeInformation",
      // },
      // {
      //   url: "/hris/employee-view/employeeinformation",
      //   name: "Employee Information",
      //   slug: "employeeinformation",
      //   icon: "InfoIcon",
      //   i18n: "EmployeeInformation",
      // },
    ],
  },
  {
    header: "Payroll",
    i18n: "Payroll",
    rule: "payroll",
    items: [
      {
        url: "/payroll/createpayroll",
        name: "Create Payroll",
        slug: "createpayroll",
        icon: "FilePlusIcon",
        i18n: "Create Payroll",
      },
      // {
      //   url: "/payroll/payroll",
      //   name: "Payroll",
      //   slug: "payroll",
      //   icon: "DollarSignIcon",
      //   i18n: "Payroll",
      // },
      {
        url: "/payroll/hoursrendered",
        name: "Allowances Deductions",
        slug: "hoursrendered",
        icon: "ClockIcon",
        i18n: "HoursRendered",
      },
      // {
      //   url: "/payroll/earnings",
      //   name: "Earnings",
      //   slug: "earnings",
      //   icon: "PlusIcon",
      //   i18n: "Earnings",
      // },
      // {
      //   url: "/payroll/deductions",
      //   name: "Deductions",
      //   slug: "deductions",
      //   icon: "MinusIcon",
      //   i18n: "Deductions",
      // },
      {
        url: "/payroll/otherreports",
        name: "Other Reports",
        slug: "otherreports",
        icon: "LayersIcon",
        i18n: "Other Reports",
      },
      {
        url: "/payroll/settings",
        name: "Settings",
        slug: "settings",
        icon: "SettingsIcon",
        i18n: "Settings",
      },
      // {
      //   url: "/payroll/uploads",
      //   name: "Payroll Uploads",
      //   slug: "payrolluploads",
      //   icon: "UploadIcon",
      //   i18n: "Payroll Uploads",
      // },
      {
        url: "/payroll/yeartodatebalance",
        name: "YTD",
        slug: "YTD",
        icon: "SettingsIcon",
        i18n: "YTD",
      },
    ],
  },
  {
    header: "Admin",
    i18n: "Admin",
    rule: "administrator",
    items: [
      {
        url: "/admin/companylist",
        name: "Company",
        slug: "company",
        icon: "UsersIcon",
        i18n: "Company",
      },
      {
        url: "/admin/masterfileupload",
        name: "MasterFile Upload",
        slug: "masterfileupload",
        icon: "UsersIcon",
        i18n: "MasterFile Upload",
      },

      {
        url: "/admin/settings",
        name: "Settings",
        slug: "settings",
        icon: "CheckCircleIcon",
        i18n: "Settings",
      },
    ],
  },
];
